import { Reducer } from 'redux';
import { CHANGE_THEME, changeTheme } from './Actions';
import { ThemeName } from '../types/Theme';

type State = ThemeName;
type Action =
    | ReturnType<typeof changeTheme>
    | { type: 'OTHER_ACTION'; payload?: any };

const ThemeReducer: Reducer<State, Action> = (
    previousState = 'dark',
    action
) => {
    if (action.type === CHANGE_THEME) {
        return action.payload;
    }
    return previousState;
};

export default ThemeReducer;